import script from "./CustomerAdd.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerAdd.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerAdd.vue?vue&type=style&index=0&id=77c67728&lang=scss"

const __exports__ = script;

export default __exports__